import React from 'react'
import './worktogether.scss'
import { Container } from 'react-bootstrap';
import VideoPlayer from '../../layout/videoplayer';
import { Link } from 'react-router-dom';

const WorkTogether = () => {
    return (
        <div className='worktogether'>
            <div className='Thank-you-wrapper'>
                <Container>
                    <div className='top-details'>
                        <h3>Working together for our clients</h3>
                        <p>We handpick agents like Rancho Mesa Insurance Services to work with our seasoned commercial underwriters located in the same marketplace—in this case, southern California.
                            We work together to find the best solutions to help protect our shared clients. {" "}
                            <Link to=""> Learn more about our relationship</Link>.</p> 
                    </div>
                    <div className='vdo_section'>
                        <div className='videos'>
                            <VideoPlayer videoSrc="https://www.w3schools.com/html/mov_bbb.mp4" />
                        </div>
                        <div className='italic_text'>
                            <div className='text'>
                                "Aside from the fact that Sentry offers great products and great service, I think it’s the personal relationship that’s really made the difference for us."
                            </div>
                            <div className='author'>David Garcia </div>
                            <div className='small_description'>President and CEO Rancho Mesa</div>
                        </div>
                    </div>
                </Container>
            </div>
        </div>
    )
}

export default WorkTogether;
